<div style="text-align:center">
  <div style="display:inline-block; padding:10px;">
    <div class="dashboard-tile">
      <div class="tile-header" style="display: inline-block">
        <div class="tile-header-title">Overall Risk</div>
        <div class="tile-header-action" style="margin:0 0 0 auto; height:100%">
          <div style="height: 30px;border-radius: 5px;margin: 10px 5px 0 0;padding: 0 5px;display: inline-block;line-height: 2.3;" [ngStyle]="{'background-color': getNistFunctionRiskColorByLabel(getOverallRisk())}">
              {{ getOverallRisk() }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngFor="let nistFunction of nistFunctions; let idx = index;" style="display:inline-block; padding:10px;">
    <div class="dashboard-tile selectable" [ngClass]="{'bg-primary-selected': selectedNistFunction==nistFunction}"
      (click)="selectNistFunction(nistFunction)">
      <div class="tile-header" style="display: inline-block">
        <div class="tile-header-title">{{getNistFunctionText(nistFunction)}}</div>
        <div class="tile-header-action" style="margin:0 0 0 auto; height:100%">
          <div style="display: inline-block; vertical-align: middle; font-size:10px; line-height:normal;">

            <div class="risk-icon" [ngClass]="{'selected':getNistFunctionRisk(nistFunction) == 'Critical'}">
              <div class="text-block">
                <ng-container *ngIf="getNistFunctionRisk(nistFunction) == 'Critical'">{{getNistFunctionRisk(nistFunction)}}</ng-container>
              </div>
              <div class="color-block" [ngStyle]="{'background-color': getNistFunctionRiskColorByLabel('Critical')}"></div>
            </div>

            <div class="risk-icon" [ngClass]="{'selected':getNistFunctionRisk(nistFunction) == 'High'}">
              <div class="text-block">
                <ng-container *ngIf="getNistFunctionRisk(nistFunction) == 'High'">{{getNistFunctionRisk(nistFunction)}}</ng-container>
              </div>
              <div class="color-block" [ngStyle]="{'background-color': getNistFunctionRiskColorByLabel('High')}"></div>
            </div>

            <div class="risk-icon" [ngClass]="{'selected':getNistFunctionRisk(nistFunction) == 'Medium'}">
              <div class="text-block">
                <ng-container *ngIf="getNistFunctionRisk(nistFunction) == 'Medium'">{{getNistFunctionRisk(nistFunction)}}</ng-container>
              </div>
              <div class="color-block" [ngStyle]="{'background-color': getNistFunctionRiskColorByLabel('Medium')}"></div>
            </div>

            <div class="risk-icon" [ngClass]="{'selected':getNistFunctionRisk(nistFunction) == 'Low'}">
              <div class="text-block">
                <ng-container *ngIf="getNistFunctionRisk(nistFunction) == 'Low'">{{getNistFunctionRisk(nistFunction)}}</ng-container>
              </div>
              <div class="color-block" [ngStyle]="{'background-color': getNistFunctionRiskColorByLabel('Low')}"></div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
